import { Component, Input } from '@angular/core';
import { Events } from '../events';
import { FormBuilder, FormControl } from '@angular/forms';
import { EventsService } from '../events.service';
import { eventsValidator } from '../new-event/events-validation.directive';

@Component({
  selector: 'app-selected-event',
  templateUrl: './selected-event.component.html',
  styleUrls: ['./selected-event.component.css']
})
export class SelectedEventComponent {

  @Input() selectedEvent?: Events
  
  constructor(private formBuilder: FormBuilder, private eventsService: EventsService) { }

  ngOnChanges() {
    this.resetForm()
  }

  editingEvents = false

  //FIXME: - upload file
  newFile: File | undefined
  newFileName: string | undefined

  eventsForm = this.formBuilder.group({
    name: [''],
    description: [''],
  }, { validators: eventsValidator })

  nameControl = <FormControl>this.eventsForm.get('name');
  descriptionControl = <FormControl>this.eventsForm.get('description');


  editEvents() {
    this.editingEvents = true
    this.eventsService.keepFocus = true
  }

  removeEvents() {
    this.eventsService.deleteEvent(this.selectedEvent!!)
  }

  cancelUserEditing() {
    this.resetForm()
    this.editingEvents = false
    this.eventsService.keepFocus = false
  }

  resetForm() {
    this.nameControl.setValue(this.selectedEvent!!.name)
    this.descriptionControl.setValue(this.selectedEvent!!.description)
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.newFile = file
        this.newFileName = file.name
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.newFile = undefined
    this.newFileName = undefined
  }

  cancelClicked() {
    this.eventsService.addEventCancelled()
    this.editingEvents = false
  }

  submitEventsEdits() {
    const editedEvents = this.createEventsFromForm()
    if (JSON.stringify(editedEvents) === JSON.stringify(this.selectedEvent) && this.newFile == undefined) {
      this.cancelUserEditing()
      alert("No changes made")
      return
    }
    this.eventsService.updateEvent(editedEvents, this.newFile)
  }

  createEventsFromForm(): Events {
    const uid = this.selectedEvent?.uid!!
    const name = this.eventsForm.value.name!!
    const description = this.eventsForm.value.description!!
    return ({uid: uid, name: name, description: description }) as Events
  }
}
